<template>
  <div id="app">
    <Modal v-show="visible" @close="close">
      <template v-slot:header>Composição da base para cálculo das horas interjornada</template>
      <template v-slot:body>

        <table class="tabela">
            <tr>
                <td>Somar</td>
            </tr>

            <tr>
                <td><input type="checkbox" v-model="HInter_base1" value="1"></td> 
                <td class="align_left">Salário </td>
            </tr>

            <tr v-if="plan_v.checkGratA">
                <td><input type="checkbox" v-model="HInter_base2" value="1"></td>
                <td class="align_left">{{ plan_v.descGratA }}</td>
            </tr>

            <tr v-if="plan_v.checkGratB">
                <td><input type="checkbox" v-model="HInter_base3" value="1"></td>
                <td class="align_left">{{ plan_v.descGratB }}</td>
            </tr>

            <tr v-if="plan_v.checkGratC">
                <td><input type="checkbox" v-model="HInter_base4" value="1"></td>
                <td class="align_left">{{ plan_v.descGratC }}</td>
            </tr>
    
            <tr v-if="plan_v.equiparacaoSalarial">
                <td><input type="checkbox" v-model="HInter_base7" value="1"></td>
                <td class="align_left">Diferenças da equiparação salarial</td>
            </tr>
        
            <tr v-if="plan_v.diferencasSalariais">
                <td><input type="checkbox" v-model="HInter_base8" value="1"></td>
                <td class="align_left">Diferenças Salariais</td>
            </tr>

            <tr v-if="plan_v.insalubridade">
                <td><input type="checkbox" v-model="HInter_base5" value="1"></td>
                <td class="align_left">Insalubridade</td>
            </tr>

            <tr v-if="plan_v.periculosidade">
                <td><input type="checkbox" v-model="HInter_base6" value="1"></td>
                <td class="align_left">Periculosidade</td>
            </tr>

            <tbody v-for="vc in verbasCriadas">
              <tr v-if="plan_v[vc.codigo]">
                <td><input type="checkbox" v-model="HInter_baseVC[vc.codigo]" value="1"></td>               
                <td class="align_left">{{vc.nome}} </td>  
              </tr>
            </tbody>

        </table>

        <button  type="button"   class="btn-open-modal"  @click="enviaForm"   aria-label="Close Modal"> OK </button>
        <button  type="button"   class="btn-open-modal"  @click="close"   aria-label="Close Modal"> Cancela </button>

      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "./modal";

export default {
  name: "App",
  components: {
    Modal,
  },
  data() {
    return {
      visible: false,
      HInter_base1: false,
      HInter_base2: false,
      HInter_base3: false,
      HInter_base4: false,
      HInter_base5: false,
      HInter_base6: false,
      HInter_base7: false,
      HInter_base8: false,
      HInter_baseVC: {} 
    };
  },
  methods: {
    openModal(dadosOrigem1) {
      // console.log('dadosOrigem1',dadosOrigem1)
        this.visible = true;
        this.HInter_base1 = this.plan_v.HInter_base1
        this.HInter_base2 = this.plan_v.HInter_base2
        this.HInter_base3 = this.plan_v.HInter_base3
        this.HInter_base4 = this.plan_v.HInter_base4
        this.HInter_base5 = this.plan_v.HInter_base5
        this.HInter_base6 = this.plan_v.HInter_base6
        this.HInter_base7 = this.plan_v.HInter_base7
        this.HInter_base8 = this.plan_v.HInter_base8
        if (typeof this.plan_v.HInter_baseVC === 'undefined') {
          this.HInter_baseVC = {} 
        } else {
          this.HInter_baseVC = this.plan_v.HInter_baseVC
        }
    },
    close() {
      this.visible = false;
    },
    enviaForm () {
      var dados = {
        idCalc: this.$store.state.idCalc, 
        HInter_base1: this.HInter_base1, 
        HInter_base2: this.HInter_base2, 
        HInter_base3: this.HInter_base3,
        HInter_base4: this.HInter_base4,
        HInter_base5: this.HInter_base5,
        HInter_base6: this.HInter_base6,
        HInter_base7: this.HInter_base7,
        HInter_base8: this.HInter_base8, 
        HInter_baseVC: this.HInter_baseVC
      }

      this.$socket.emit('v', dados)
      this.close () 
    }
  },
  computed: {
    plan_v () {
      return  this.$store.state.variaveis 
    },
    verbasCriadas () {
                if (typeof this.$store.state.variaveis.verbasCriadas === 'undefined') return []  
                var that = this 
                return this.$store.state.variaveis.verbasCriadas.filter( function(e) {
                    return (e.calculo_especifico <= 0 || e.calculo_especifico == that.$store.state.idCalc );
                } ) 
            }
  }
};
</script>

<style scoped>

.tabela {
    width: 98%;
    background-color: #fff;

}

.align_left {
    text-align: left;
}

</style> 